import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import {provideTranslateService} from "@ngx-translate/core";

import { routes } from './app.routes';
import { AppService } from './services/app.service';
import { ApiService } from './services/api.service';
import { BaseService } from './services/base.service';
import { provideHttpClient } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    AppService,
    ApiService,
    BaseService,
    DecimalPipe,
    provideHttpClient(),
    provideRouter(routes),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: 'en'
     })
  ]
};
